import { Box, TextField, useMediaQuery, useTheme } from "@mui/material";
import VpnKeyRoundedIcon from "@mui/icons-material/VpnKeyRounded";
import CopyToClipboard from "./CopyToClipboard";

interface LicenseTextField {
  label: string;
  helper: string;
  data: string;
  focused?: boolean;
  isSmallScreen?: boolean;
  shouldFormatLicenseKey?: boolean;
}

const formatLicenseKey = (
  licenseKey: string,
  isSmallScreen: boolean
): string => {
  if (!licenseKey) return "";

  const parts = licenseKey.split("-");
  if (parts.length <= 3) return licenseKey;

  // Split into two lines
  if (isSmallScreen) {
    const lines = [];
    if (parts.length > 3) {
      lines.push(parts.slice(0, 3).join("-"));
      lines.push(parts.slice(3).join("-"));
    } else {
      lines.push(parts.join("-"));
    }
    return lines.join("\n");
  }

  return licenseKey;
};

const LicenseTextField = ({
  helper,
  label,
  data,
  focused,
  isSmallScreen = false,
  shouldFormatLicenseKey = false, // Controls formatting
}: LicenseTextField) => {
  const theme = useTheme();
  const isSmallScreenDetected = useMediaQuery(theme.breakpoints.down("sm"));
  const formattedData = shouldFormatLicenseKey
    ? formatLicenseKey(data, isSmallScreenDetected || isSmallScreen)
    : data; // Keep original data for OTP
  const isMultiline = shouldFormatLicenseKey && formattedData.includes("\n");
  console.log("Data:", data);
  console.log("Formatted Data:", formattedData);
  console.log("isMultiline:", isMultiline);
  return (
    <Box py={1}>
      <TextField
        label={label}
        color="success"
        defaultValue={formattedData}
        helperText={helper}
        multiline={isMultiline}
        rows={isMultiline ? 2 : 1}
        InputProps={{
          readOnly: true,
          style: {
            fontSize: isMultiline ? 24 : 20,
            lineHeight: isMultiline ? 1.4 : 1.2,
            letterSpacing: "0.5px",
          },
          startAdornment: (
            <VpnKeyRoundedIcon
              sx={{
                marginLeft: -0.5,
                marginRight: isMultiline ? 2 : 1, // Adjusted based on isMultiline
                opacity: 0.5,
                fontSize: isMultiline ? 24 : 20,
                alignSelf: isMultiline ? "flex-start" : "center",
                marginTop: isMultiline ? 2 : 0,
              }}
            />
          ),
          endAdornment: (
            <Box
              sx={{
                alignSelf: isMultiline ? "flex-start" : "center",
                marginTop: isMultiline ? 2 : 0,
              }}
            >
              <CopyToClipboard text={data} />
            </Box>
          ),
        }}
        fullWidth
        focused={focused}
      />
    </Box>
  );
};

export default LicenseTextField;
